import { Android, Api, Build, DesignServices, Speed, Support } from '@mui/icons-material';
import React from 'react';

const Service = () => {

     const servicesData = [
          {
               icon: <Build />,
               title: "Custom React Native App Development",
               description:
                    "We build custom mobile apps tailored to your business needs. Whether it’s a social app, e-commerce platform, or a complex enterprise solution, we ensure scalability, reliability, and responsiveness across devices."
          },
          {
               icon: <Android />,
               title: "Cross-Platform Mobile App Development",
               description:
                    "React Native allows us to write code once and deploy it on both iOS and Android platforms, saving time and costs. Our cross-platform apps maintain native-like performance and functionality."
          },
          {
               icon: <Api />,
               title: "App Integration & API Development",
               description:
                    "We integrate your React Native app with third-party services, APIs, and databases to enhance functionality and streamline your business processes. Whether it’s payment gateways, social media integrations, or cloud services, we’ve got you covered."
          },
          {
               icon: <DesignServices />,
               title: "UI/UX Design",
               description:
                    "Our design team creates beautiful and user-friendly interfaces that engage users. From wireframes to pixel-perfect designs, we ensure a seamless experience across all screen sizes."
          },
          {
               icon: <Support />,
               title: "App Maintenance & Support",
               description:
                    "We offer ongoing maintenance and support to ensure your app stays up-to-date with the latest platform versions, features, and performance improvements. We handle bug fixes, updates, and app optimization."
          },
          
          
          {
               icon: <Speed />,
               title: "Performance Optimization",
               description:
                    "Performance is key to a great user experience. We optimize your React Native app for speed, responsiveness, and memory usage, ensuring smooth performance on all devices."
          }
     ];

     return (
          <>
               <section className='__service-sec' id='service'>
                    <div className='content-center'>
                         <div className='__sc-head'>
                              <h3> Our Expert Services for Seamless Development</h3>
                              <p> We specialize in crafting high-performance React Native applications with a focus on efficiency, scalability, and user experience. From intuitive UI/UX design to backend integration and deployment, we ensure a smooth development process. Whether you're a startup or an enterprise, our solutions are tailored to meet your unique needs.</p>
                         </div>

                         <div className='__sc-body'>
                              <div className='row'>
                                   {servicesData.map((item, index) => (
                                        <div className='col-md-4' key={index}>
                                             <div className='__sc-card'>
                                                  <div className='__icon'>
                                                       <span>{item.icon}</span>
                                                  </div>
                                                  <h4> {item.title} </h4>
                                                  <p> {item.description}</p>
                                             </div>
                                        </div>
                                   ))}

                              </div>
                         </div>
                    </div>
               </section>
          </>
     );
}

export default Service;
